import * as Sentry from '@sentry/browser'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Vuelidate from 'vuelidate'
import VueFormWizard from 'vue-form-wizard'
import vuelidateErrorExtractor, { templates } from 'vuelidate-error-extractor'
import BootstrapVue from 'bootstrap-vue'
import store from './store'
import App from './App.vue'
import router from './router'
import RestDataSource from './restDataSource'
import messages from './messages'

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://6aa2ff8102c64791ab652395bf23ba37@sentry.io/1371681',
    integrations: [new Sentry.Integrations.Vue({ Vue })]
  });
}

// const version = '1.0.0'
Vue.use(VueI18n)
Vue.config.productionTip = false

Vue.use(BootstrapVue)

Vue.use(Vuelidate)
Vue.use(vuelidateErrorExtractor, {
  messages: messages.sk.errors
});
Vue.component('formWrapper', templates.FormWrapper)

Vue.use(VueFormWizard)

const i18n = new VueI18n({
  locale: 'sk',
  messages
});

new Vue({
  store,
  router,
  data: {
    eventBus: new Vue(),
  },
  render: h => h(App),
  provide() {
    return {
      eventBus: this.eventBus,
      restDataSource: new RestDataSource(this.eventBus)
    };
  },
  i18n
}).$mount('#app');
